import { ContextMenuMESFProvider } from "../../../controls/contextMenu/useContextMenuMESF";
import { CasterProcessesPage } from "./CasterProcessesPage";
import { CasterProcessesProvider } from "./context/CasterProcessesContext";

type Props = {};
const CasterProcesses = (props: Props) => {
  return (
    <ContextMenuMESFProvider>
      <CasterProcessesProvider>
        <CasterProcessesPage />
      </CasterProcessesProvider>
    </ContextMenuMESFProvider>
  );
};
export default CasterProcesses;
